<template>
<div class="form" id="form">
  <div class="form-wrap">
    <h2>
      Dowiedz się więcej
    </h2>
    <h3 class="form-tel">
      tel.: <a href="tel:+48 61 849 11 89 ">618 491 189</a>
    </h3>
    <div v-if="!message">
      <label>
        Imię
        <br />
        <span class="text-error" v-if="errors.first_name && errors.first_name.errors">
          {{ errors.first_name.message }}
          <br>
        </span>
        <input type="text" value="" v-model="formData.first_name">
      </label>

      <label>
        Nazwisko
        <br />
        <span class="text-error" v-if="errors.last_name && errors.last_name.errors">
          {{ errors.last_name.message }}
          <br>
        </span>
        <input type="text" value="" v-model="formData.last_name">
      </label>

      <label>
        Adres e-mail
        <br />
        <span class="text-error" v-if="errors.email && errors.email.errors">
          {{ errors.email.message }}
          <br>
        </span>
        <input type="text" value="" v-model="formData.email">
      </label>

      <label>
        Numer telefonu
        <br />
        <span class="text-error" v-if="errors.phone_number && errors.phone_number.errors">
          {{ errors.phone_number.message }}
          <br>
        </span>
        <input type="text" value="" v-model="formData.phone_number" maxlength="9" minlength="9">
      </label>

      <label>
        Dodatkowa wiadomość
        <br />
        <textarea name="description" v-model="formData.description"></textarea>
      </label>

      <p>
        <small>
          Aby móc przetwarzać Państwa dane w celu przesyłania Państwu informacji dotyczących promocji, akcji marketingowych, organizowanych wydarzeń w sprawie naszej działalności oraz oferowanych przez nas produktów i usług za pośrednictwem
          wskazanych poniżej kanałów komunikacji, prosimy Państwa o wskazanie preferowanych form komunikacji z Państwem poprzez wyrażenie poniżej wskazanych zgód.
          W każdej chwili mogą Państwo cofnąć zgodę na przetwarzanie danych osobowych. Cofnięcie zgody nie wpłynie jednak na zgodność z prawem przetwarzania przez nas danych osobowych przed wycofaniem zgody.
        </small>
      </p>
      <p>
        <small>
          Wyrażam zgodę na przetwarzanie moich danych osobowych w postaci adresu e-mail lub numeru telefonu (w zależności od wybranego kanału komunikacji) przez Porsche Inter Auto Polska Sp. z o.o. ("Porsche") dla celów marketingowych związanych z
          przesyłaniem/przekazywaniem przez Porsche spersonalizowanych informacji handlowo-marketingowych dotyczących produktów i usług oferowanych przez Porsche, za pośrednictwem:
        </small>
      </p>

      <label>
        <input type="checkbox" name="accept-email9" value="" v-model="formData['accept-email9']" true-value="1" false-value="0"> Email
      </label>

      <label>
        <input type="checkbox" name="accept-phone9" value="" v-model="formData['accept-phone9']" true-value="1" false-value="0"> Telefon
      </label>

      <p>
        <small>
          Administratorem Państwa danych osobowych jest spółka Porsche Inter Auto Polska Sp. z o.o. z siedzibą w Warszawie (01-304) przy ul. Połczyńskiej 118a, zarejestrowana w Sądzie Rejonowym dla m.st. Warszawy, XIII Wydział Gospodarczy Krajowego
          Rejestru Sądowego, KRS 0000108213. Mogą się Państwo z nami skontaktować przy pomocy numeru telefonu +48 22 223 15 15 oraz adresu e-mail: rodo@porscheinterauto.pl.
          <span v-if="acceptToggle">Informujemy, że podane przez Państwa dane będziemy przetwarzać w celu obsługi Państwa zapytania, w tym w celu kontaktu z Państwem w tym zakresie. Będziemy przetwarzać Państwa dane osobowe także w innych celach,
            jeśli wyrażą na to Państwo odrębną zgodę. Podanie przez Państwa danych osobowych jest dobrowolne. Przysługuje Państwu prawo do żądania od nas dostępu do swoich danych osobowych, prawo do ich sprostowania, usunięcia, ograniczenia
            przetwarzania, prawo do przenoszenia danych a także prawo do sprzeciwu wobec przetwarzania przez nas Państwa danych osobowych. Więcej na ten temat przeczytają Państwo w naszej Polityce Prywatności (http://www.porscheinterauto.pl/rodo).</span>
          <br>
          <strong v-on:click="acceptToggle = !acceptToggle" v-if="!acceptToggle">Rozwiń</strong>
          <strong v-on:click="acceptToggle = !acceptToggle" v-if="acceptToggle">Zwiń</strong>
        </small>
      </p>


      <button class="c-btn" v-on:click="sendForm()">Wyślij</button>
      <br><br>
      <small>
        Prezentowane informacje są wyłącznie informacją handlową i nie stanowi oferty w myśl art. 66 § 1 i art. 556 indeks 1 Kodeksu Cywilnego. Porsche Inter Auto Polska zastrzega sobie prawo do doprecyzowania oraz korekt omyłek.
      </small>
    </div>
    <div v-if="message">
      <h2 class="text-center successform" v-html="message"></h2>
    </div>
  </div>




</div>
</template>

<script>
import {
  mapGetters
} from 'vuex';
export default {
  name: 'contactForm',
  data() {
    return {
      message: false,
      formUrl: "https://lms-api.activemotors.pl/send/",
      formData: {
        department_id: 1,
        dealer_id: 4,
        origin_id: 11,
        ip: "85.221.212.38",
        url: window.location.href,
        campaign_id: 788,
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        description: "",
        "accept-phone9": 0,
        "accept-email9": 0
      },
      countclick: 0,
      acceptToggle: false,
      errors: {}
    }
  },
  computed: {
    ...mapGetters(['getSelectedOffer'])
  },
  watch: {
    getSelectedOffer: {
      handler: function() {
        this.formData.description = this.getSelectedOffer;
      },
      deep: true
    }
  },
  validate: {
    rules: {
      first_name: {
        required: true
      },
      last_name: {
        required: true
      },
      email: {
        requireGroup: 'd',
        email: true
      },
      phone_number: {
        requireGroup: 'd',
        phone: true
      }
    },
    messages: {
      first_name: {
        required: "To pole jest wymagane!"
      },
      last_name: {
        required: "To pole jest wymagane!"
      },
      email: {
        requireGroup: "To pole jest wymagane!",
        email: "Błędny adres E-mail"
      },
      phone_number: {
        requireGroup: "To pole jest wymagane!",
        phone: 'Błędny numer telefonu'
      }
    }
  },
  methods: {
    sendForm() {
      var that = this;
      this.errors = {};
      this.errors = this.$vaLittle.check(this.formData);

      if (!this.errors.errors) {
        this.countclick += 1;
        var form_data = new FormData();

        for (var key in that.formData) {
          form_data.append(key, that.formData[key]);
        }

        if (this.countclick == 1) {
          this.axios
            .post(this.formUrl, form_data)
            .then(function(response) {
              that.message = response.data.msg;
              gtag('event', 'Wysłanie formularza');
              // var s = 1e13 * (Math.random() + ""),
              //   n = document.createElement("span");
              // n.innerHTML = '<iframe src="https://9856777.fls.doubleclick.net/activityi;src=9856777;type=lead-0;cat=pia-a00;u5=' + that.formData.phone_number + ";u7=" + that.formData.dealer_id +
              //   ";dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=" + s + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>';
              // document.body.insertBefore(n, document.body.firstChild)

            })
            .catch(function(error) {
              window.alert(
                "Błąd wysyłania zgłoszenia. Sprawdź swoje połączenie z internetem"
              );
            })
        }

      }
    }
  },
  mounted() {
    // track phone numbers click
    // document.querySelectorAll("a[href^=tel").forEach(function(e) {
    //   e.addEventListener('click', function() {
    //     console.log('tel');
    //     gtag('event', 'Kliknięcie w numer telefonu');
    //     var axel = Math.random() + "";
    //     var a = axel * 10000000000000;
    //     var p = document.createElement("span");
    //     p.innerHTML = '<img src="https://ad.doubleclick.net/ddm/activity/src=9856777;type=lead-0;cat=pia-a000;u1=' + window.location.href + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a +
    //       '?" width="1" height="1" alt=""/>';
    //     document.body.appendChild(p);
    //   });
    // });

  }
}
</script>

<style lang="scss" scoped>
.form {
    max-width: 540px;
    width: 40vw;
    min-width: 320px;
    padding: 2rem;
    background-color: #bb0a30;
    color: #fff;
    top: 0;
    a {
        color: #fff;
        text-decoration: none;
    }
    @media(max-width: 1280px) {
        max-width: 380px;
    }
    @media(max-width: 780px) {
        max-width: 780px;
        width: 100%;
    }
    @media(max-width: 320px) {
        min-width: auto;
    }

    /* width */
    *::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    *::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    *::-webkit-scrollbar-thumb {
        background: #333;
    }

    /* Handle on hover */
    *::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    &-wrap {
        position: sticky;
        top: 0;
        max-height: 98vh;
        overflow-y: auto;
        padding-right: 0.5rem;
        @media (max-height: 930px) {
            overflow-y: scroll;
            max-height: 96vh;
            padding-right: 1rem;

        }
        padding-top: 1rem;
    }
    &-tel {
        font-size: 1.25rem;
    }
}
input[type=text],
textarea {
    padding: 0.75rem 1rem;
    width: 100%;
    border: 0;
    border-radius: 4px;
    margin: 0.5rem 0;
}
input[type=checkbox] {
    position: relative;
}
input[type=checkbox]::after {
    content: ' ';
    display: block;
    width: 1rem;
    height: 1rem;
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #fff;
    text-align: center;
}
input[type=checkbox]:checked::after {
    content: '✓';
    line-height: 1rem;
}
button {
    padding: 0.75rem 2rem;
    border: 0;
    background: #fff;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: bold;
    text-transform: uppercase;
}
p {
    font-size: 0.75rem;
}
.text-error {
    font-size: 0.7rem;
    color: #c4c4c4;
}
</style>
